
document.addEventListener('DOMContentLoaded', function() {
  const updatePrice = (value) => {
    var priceInputs = document.querySelectorAll("[data-product-price]")
    priceInputs.forEach(function(priceInput) {
      const currentPrice = priceInput.textContent
      const newPrice = String(value)
      if (currentPrice !== newPrice) {
       priceInput.textContent = value
      }
    })
  }

  document.addEventListener("sabah:selected-variant", (e) => updatePrice(formatMoney(e.detail.price, '${{amount_no_decimals}}')));
})
